module.exports = "/_next/static/images/1253e1c797e1e2b455399028e4e59078-medium-reuters.png.webp";